import { Box } from "@mui/material";
import { StripeCardCvcTextField, StripeCardExpiryTextField, StripeCardNumberTextField } from "../../Stripe";
import { StripeCardNumberElementOptions, StripeCardNumberElementChangeEvent } from "@stripe/stripe-js";

import { useState } from "react";

const creditCardOptions: StripeCardNumberElementOptions = {
    placeholder: "**** **** **** ****",
};

export default function StripePaymentForm() {
    const [cardBrand, setCardBrand] = useState<StripeCardNumberElementChangeEvent["brand"]>("unknown");

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }} data-test-id="section_stripe_payment_form">
            <Box sx={{ width: "100%" }}>
                <StripeCardNumberTextField
                    data-test-id="input_stripe_credit_card_number"
                    label="Credit Card Number"
                    name="creditCardNumber"
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <img
                                src={`/images/cards/${cardBrand}.svg`}
                                alt="credit card brand logo"
                                height={22}
                                data-test-id="image_card_brand_logo"
                            />
                        ),
                    }}
                    options={creditCardOptions}
                    onChange={(e: StripeCardNumberElementChangeEvent) => setCardBrand(e.brand)}
                />
            </Box>

            <Box sx={{ display: "flex", gap: "24px" }}>
                <Box sx={{ flex: 1 }}>
                    <StripeCardExpiryTextField
                        data-test-id="input_stripe_expiration_date"
                        fullWidth
                        label="Exp. Date"
                        name="expirationDate"
                    />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <StripeCardCvcTextField data-test-id="input_stripe_cvv" fullWidth label="CVV" name="cvvNumber" />
                </Box>
            </Box>
        </Box>
    );
}
